export default {
  computed: {
    titleName: function titleName() {
      return useTitleData().titleName;
    },
    backPath: function backPath() {
      return useTitleData().backPath;
    },
    backPrev: function backPrev() {
      return useTitleData().backPrev;
    },
    isBackButtonShown: function isBackButtonShown() {
      return this.backPath || this.backPrev;
    },
    hasHelpButton: function hasHelpButton() {
      return useTitleData().hasHelpButton;
    },
    strLength: function strLength() {
      return useTitleData().titleName.length;
    }
  },
  methods: {
    back: function back() {
      if (this.backPath) {
        return this.$router.push(this.backPath);
      } else if (this.backPrev) {
        return this.$router.back();
      }
    },
    setIsHelpModalShown: function setIsHelpModalShown() {
      useTitleData().setIsHelpModalShown(true);
    }
  }
};